if (!window.DigitalizModules) window.DigitalizModules = {};

if (!window.DigitalizModules.HeroVideo) {
  const MOBILE_QUERY = '(max-width: 767px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  class HeroVideo {
    constructor(el) {
      this.el = el;
      this.root = el.closest('.section-hero-image');
      this.src = '';
      this.onPlaying = this.onPlaying.bind(this);
      this.onError = this.onError.bind(this);
      this.init();
    }

    init() {
      if (this.el.dataset.heroVideoReady === 'true') return;
      this.el.dataset.heroVideoReady = 'true';

      // Reduced motion: never fetch the video at all. This is the one case where
      // the image is the intended experience, so leave the markup untouched.
      if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return;

      // The rendition is picked once and kept — re-selecting on resize would
      // restart playback and re-download the file.
      this.src = window.matchMedia(MOBILE_QUERY).matches
        ? this.el.dataset.srcMobile
        : this.el.dataset.srcDesktop;

      if (!this.src || !this.root) return;

      this.el.addEventListener('playing', this.onPlaying);
      this.el.addEventListener('error', this.onError);

      // Hide the image and show the spinner up front, so the image is never used
      // as a loading placeholder, then start fetching straight away.
      this.root.classList.add('is-video-active', 'is-video-loading');
      this.load();
    }

    load() {
      this.el.src = this.src;

      const played = this.el.play();
      if (played && typeof played.catch === 'function') {
        // Autoplay refused (low power mode, data saver) — fall back to the image
        // rather than leaving the spinner running forever.
        played.catch(this.onError);
      }
    }

    onPlaying() {
      this.root.classList.remove('is-video-loading');
      this.el.classList.add('is-playing');
    }

    onError() {
      this.root.classList.remove('is-video-active', 'is-video-loading');
      this.el.classList.remove('is-playing');
    }

    destroy() {
      this.el.removeEventListener('playing', this.onPlaying);
      this.el.removeEventListener('error', this.onError);
      if (this.root) this.root.classList.remove('is-video-active', 'is-video-loading');
      this.el.pause();
      this.el.removeAttribute('src');
      this.el.load();
      delete this.el.dataset.heroVideoReady;
    }
  }

  window.DigitalizModules.HeroVideo = HeroVideo;

  function initAll(root) {
    root.querySelectorAll('[data-hero-video]').forEach(el => new HeroVideo(el));
  }

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
    if (event.target.matches('[data-hero-video]')) new HeroVideo(event.target);
  });
}
